import React, { useEffect } from 'react';
import Banner from '../../components/public/Banner/Banner';
import { Box, Typography } from '@mui/material';
import GrillaEspectaculos from '../../components/public/GrillaEspectaculos/GrillaEspectaculos';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGrillaEspectaculos } from 'utils/redux/features/espectaculosGrillaSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import { EspectaculoBanner, ICaratulaEspectaculo } from 'utils/models/types';
import SuscripcionBoletin from 'components/public/SuscripcionBoletin/SuscripcionBoletin';
import { useNavigate } from 'react-router-dom';
import { getCompraConExpiracion } from 'utils/utilities';
import { API_BASE_URL } from 'services/constants';

const Home = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { grillaEspectaculos, loadingGrillaEspectaculos, errorGrillaEspectaculos } = useSelector(
    (state: RootState) => state.espectaculosGrilla
  );
  const espectaculos = Array.isArray(grillaEspectaculos) ? grillaEspectaculos : [];

  const visiblesEnGrilla = espectaculos.filter(e => e.VisibleEnGrilla);
  const datosCompraJSON = getCompraConExpiracion('datosCompra');
  const datosCompra = datosCompraJSON && JSON.parse(datosCompraJSON);

  const navigate = useNavigate();
  const redirectPath = localStorage.getItem('redirectPath')?.replace('/compra', '');
  // Sólo mostrar banners destacados, y validar que si alguno fue destacado pero no existe, no lo muestre

  const baseURL = API_BASE_URL?.replace('api/', '');
  const bannersDestacados: ICaratulaEspectaculo[] = espectaculos.filter(
    e => e.BannerDestacado === true && e.BannerUrl !== baseURL
  );
  const banners: EspectaculoBanner[] = bannersDestacados.map((e: ICaratulaEspectaculo) => {
    return {
      Id: e.Id,
      Nombre: e.Nombre,
      Descripcion: e.Descripcion,
      FechaInicio: e.Fechas[0]?.FechaInicio,
      FechaFin: e.Fechas[e.Fechas.length - 1]?.FechaInicio,
      Director: e.Director,
      BannerUrl: e.BannerUrl,
    };
  });

  useEffect(() => {
    dispatch(fetchGrillaEspectaculos());
  }, [dispatch]);

  useEffect(() => {
    if (redirectPath && datosCompra) {
      navigate(redirectPath);
    }
    localStorage.removeItem('redirectPath');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      {loadingGrillaEspectaculos ? (
        <Spinner />
      ) : !errorGrillaEspectaculos ? (
        <Box position="relative">
          <Banner interval={10000} banners={banners} />

          {espectaculos.length > 0 ? (
            <GrillaEspectaculos
              titulo="Cartelera de espectáculos"
              path="espectaculos"
              elementos={visiblesEnGrilla} // Solo paso los espectáculos visibles en grilla
              textoBoton="Ver más"
              mostrarFechas
            />
          ) : (
            <Box
              textAlign="center"
              mb="270px"
              mt={5}
              height="100%"
              minHeight="400px"
              display="flex"
              flexDirection="column"
              justifyContent="center"
            >
              <Typography variant="h6">¡Regresá pronto para tener novedades!</Typography>
              <Typography variant="body1" fontSize="1.2rem">
                Actualmente no tenemos espectáculos en cartelera.
              </Typography>
            </Box>
          )}
          <SuscripcionBoletin />
        </Box>
      ) : (
        <NoResponse />
      )}
    </Box>
  );
};

export default Home;
